<template>
  <v-container class="cmpbk_drk white--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <div class="pa-2">
      <h1 class="white--text">Subscribe to RPD News Gate</h1>
      <p>
        Welcome. You may submit an email to receive all RPD News Releases as
        they come out. You will receive an email with a code to paste here to
        confirm the ownership of your email address.
      </p>
    </div>
    <template>
      <v-form v-model="valid" lazy-validation ref="form">
        <v-card
          shaped
          elevation="3"
          class="ma-2 pa-2 mb-4 cmpbk_lght white--text"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    dark
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn class="accent black--text" @click="submit">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </template>
    <v-spacer style="height: 20px"></v-spacer>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "subscribe",
  mixins: [bus_common],
  data: () => ({
    valid: false,
    firstname: "",
    lastname: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => v.length <= 10 || "Name must be less than 10 characters",
    ],
    email: "jvonmolt@gmail.com",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
  }),
  methods: {
    submit() {
      console.log("sub");
      this.mrbreakpoint("save");
      if (this.$refs.form.validate() == false) {
        this.swall_it(
          "Submit Status",
          "Some fields are incorrect. Please address the red fields before submitting.",
          "warning",
          null,
          null
        );
        return true;
      }
      this.show_loader(true);
      let formIn = {};
      formIn.email = this.email;
      formIn.apiname = "sub_submit";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(true);
          console.log(data);
          this.swall_it("Submit Status", "Success.", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
